module.exports = __webpack_public_path__ + "img/1-03.de9f8cfd.png";